export const defaultMemberPaymentCardWalletState = {
    showModal: false,
    showForm: false,
    isLoading: true,
    hasFailedToLoad: false,
    disableActionButtons: false
};
